var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"base_button",style:(_vm.buttonStyles),attrs:{"title":_vm.title,"id":_vm.id,"disabled":_vm.disabled},on:_vm._d({},[_vm.EVENTS.CLICK,_vm.handleClick])},[(_vm.prefixIcon)?_c('base-icon',{attrs:{"icon":_vm.prefixIcon,"color":_vm.buttonStyles['--color']}}):_vm._e(),(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }